import { useCallback, useEffect, useRef, useState } from "react";
import {  getAllInventory,getSkuMapplingById,updateSkuMappling } from "../../services/AllServices";
import { setLabel, showMessage } from "../../utils/helpers";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";

const useEditMappingViewController = () => {

   
    const [gwpList, setGwpList] = useState([]);
    const [mappingData, setMappingData] = useState({});
    const [editState, setEditState] = useState(true);
    const { id } = useParams();
    const navigate = useNavigate();
    const renderAfterCalled = useRef(false);
    const [loading, setLoading] = useState(false);
    const fetchData = useCallback(async () => {
      try {
        setLoading(true);
        let responseData = await getSkuMapplingById(id);
        setMappingData(responseData?.data);
        let gwpData = await getAllInventory("GWP/Merchandise");
  
        let updatedgwpData = gwpData?.data?.map((item) => {
          return {
            label: setLabel(item),
            value: {
              item_sid: item?.sid,
              item_category: item?.udf1string,
              item_name: item?.description1,
              item_hs_id: item?.alu,
              item_watson_id: item?.description3,
            },
          };
        });
        setGwpList(updatedgwpData);
      } catch (error) {
        showMessage("error", error?.response?.data?.message || "Something went wrong");
      }
      setLoading(false);
    }, [id]);
    useEffect(() => {
      if (!renderAfterCalled.current) {
        fetchData();
      }
      renderAfterCalled.current = true;
    }, [fetchData]);
  
    const { touched, setFieldValue, errors, values, handleSubmit } = useFormik({
      initialValues: {
        gwp_sku_item: "",
      },
      onSubmit: async () => {
        setLoading(true);
        try {
          await updateSkuMappling(id, values?.gwp_sku_item);
          showMessage("success", "Mapping Updated Successfully");
          fetchData();
        } catch (error) {
          showMessage("error", error?.response?.data?.message || "Something went wrong");
        }
        setLoading(false);
      },
    });
  
    const goBack = () => {
      navigate("/mapping-management");
    }

    return {
        goBack,
    values,
    touched,
    errors,
    setFieldValue,
    handleSubmit,
    gwpList,
    mappingData,
    editState,
    setEditState,
    loading,
    };
};

export default useEditMappingViewController;